import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-test-migration',
  templateUrl: './test-migration.component.html',
  styleUrls: ['./test-migration.component.scss']
})
export class TestMigrationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
